export default __webpack_public_path__ + "static/media/person_act.9f0dc5a5.svg";